<template>
  <section class="font-ww-medium bg-[#e6e9f0]">
    <div class="flex flex-col gap-6 items-center px-5 py-10 mx-auto lg:py-20 max-w-container md:flex-row lg:flex-row">
      <div class="w-full md:mb-0 dyn_img">
        <div class="flex flex-col items-center text-center lg:flex-grow">
          <h1 class="mb-4 text-3xl font-black h1 lg:text-4xl md:mb-12 md:text-2xl" style="color:#000000" v-html="title"></h1>
        </div>
        <div class="relative mx-auto max-w-screen-md yt-lazyload" data-id="XTANv5u4wEI" data-thumb="" data-logo="2">
          <div class="yt-lazyload-wrap">
            <div class="yt-lazyload-content"  @click="playVid()" role="img" :aria-label="videoTitle" style="background-image: url(assets/images/XTANv5u4wEI.jpg);">
              <iframe
                  allow="accelerometer;autoplay;encrypted-media;gyroscope;picture-in-picture"
                  v-if="videoPLay"
                  id="myVideo"
                  :src="youtubeLink"
                  class="absolute top-0 left-0 w-full h-full rounded-3xl">
              </iframe>
              <div role="button" tabindex="0" v-if="!showVideo" class="yt-lazyload-playbtn"></div>
              <button class="yt-lazyload-logo" v-if="!showVideo"></button>
            </div>
          </div>
        </div>
        <div class="flex flex-col items-center pt-6 mx-auto max-w-screen-md text-center lg:flex-grow md:pt-12">
          <a @click.prevent="scrollTo('#steps')" class="px-10 w-full cursor-pointer btn-red lg:px-16 lg:py-2 sm:text-2xl">{{buttonText}}
            TODAY!</a>
        </div>


      </div>

    </div>
  </section>
</template>

<script setup>

const videoTitle = ref('Youtube Logo');

const showVideo = ref(false);
const videoPLay = ref(false);

const playVid = () => {
  videoPLay.value = true;
  showVideo.value = true;
};

defineProps({
  title: {
    type: String,
    default: 'The News is\n' +
        '            Talking About<br> Lifeboost Coffee'
  },
  buttonText: {
    type: String,
    default: 'TRY LIFEBOOST FOR UP TO 58% OFF'
  },
  youtubeLink: {
    type: String,
    default: 'https://www.youtube.com/embed/XTANv5u4wEI?autoplay=1'
  },
})


defineBuilderComponent({
    friendlyName: "SectionWithVideo",
    inputs: [
        {
            name: "title",
            type: "richText",
            defaultValue: "The News is\n Talking About<br> Lifeboost Coffee"
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "TRY LIFEBOOST FOR UP TO 58% OFF"
        },
        {
            name: "youtubeLink",
            type: "string",
            defaultValue: "https://www.youtube.com/embed/XTANv5u4wEI?autoplay=1"
        }
    ]
});
</script>

<style>
.yt-lazyload-wrap {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: inherit;
}

.yt-lazyload-content {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #000;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
}

.yt-lazyload-wrap {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: inherit;
}

.yt-lazyload::before {
  content: '';
  width: 100%;
  display: block;
  position: relative;
  padding-top: 56.25%;
  background-color: #000;
}


.yt-lazyload-playbtn {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  background-image: url('public/assets/images/download.svg');
  background-position: 50%;
  background-size: calc(35px + 10%) auto;
  background-repeat: no-repeat;
}

.yt-lazyload[data-logo="2"] .yt-lazyload-logo {
  background-image: url('public/assets/images/youtube.svg');
}

.yt-lazyload-playbtn:hover {
  background-image: url('public/assets/images/download-color-youtube.svg');
}

.yt-lazyload-logo {
  display: block;
  width: 30%;
  min-width: 95px;
  min-height: 22px;
  max-width: 215px;
  padding-top: 6.8%;
  position: absolute;
  right: 4%;
  bottom: 4%;
  z-index: 2;
  background-position: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: .75;
  transition: opacity .3s;
}
</style>